<template>
  <transition name="modal">
    <div class="modalMask" v-show="show">
      <div class="modalWrapper checkPrivacyModal" @click.self="handleClick">
        <div class="modalContainer">
          <div class="modalHeader">
            <h1>개인정보 수집 및 이용동의</h1>
            <button class="btn_close" @click="$emit('closeModal')"><i class="icon iconDel"></i></button>
          </div>
          <div class="modalBody">
            <h2 class="subTitle">[개인정보 수집 및 이용 동의]</h2>
            <p class="desc">
              (주) 넥슨코리아는 다음과 같이 개인정보를 수집 및 이용하고 있습니다.
            </p>
            <ul class="detail">
              <li>
                <strong>수집 및 이용목적</strong>
                <span>상품배송</span>
              </li>
              <li>
                <strong>개인정보 항목</strong>
                <span>이름, 전화번호, 주소</span>
              </li>
              <li>
                <strong>보유 및 이용기간</strong>
                <span>수집일로부터 1년 또는 회원탈퇴일로부터 30일 미동의 시 상품구매를 진행할 수 없습니다.</span>
              </li>
            </ul>

            <h2 class="subTitle">[개인정보 처리 위탁 안내]</h2>
            <p class="desc">
              (주) 넥슨코리아는 다음과 같이 개인정보를 위탁하고 있습니다.
            </p>
            <ul class="detail">
              <li class="narrow">
                <strong>위탁업체</strong>
                <span>{{ consignmentCompany }}</span>
              </li>
              <li class="narrow">
                <strong>위탁목적</strong>
                <span>상품배송</span>
              </li>
            </ul>

            <p class="desc">
              ※ 그 외의 사항 및 자동 수집 정보와 관련된 사항은
              개인정보처리방침을 따릅니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('main', ['consignmentCompany']),
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    handleClick() {
      this.$emit('closeModal')
    },
  }
}
</script>

<style lang="scss" scoped>
.checkPrivacyModal {
  min-width: 310px;
  min-height: 350px;
  padding: 0 10px 10px;

  .modalHeader {
    position: relative;
    height: 50px;

    h1 {
      font-size: 15px;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: center;
      color: #151721;
    }
    .btn_close {
      position: absolute;
      top: 5px;
      right: 5px;
    }
  }

  .modalBody{
    padding: 5px;
    background-color: #f7f7f7;

    .subTitle {
      height: auto;
      padding: 5px 0;
      font-size: 12px;
      color: #151721;
      border-bottom: 0;
    }
    .desc {
      font-size: 10px;
      line-height: 1.5;
      color: #666679;
      word-break: keep-all;
    }

    .detail {
      margin: 10px 0 20px;

      & > li {
        display: flex;
        font-size: 10px;
        line-height: 1.5;
        letter-spacing: normal;
        text-align: left;

        strong, span {
          display: block;
          word-break: keep-all;
        }

        strong {
          width: 30%;
          display: flex;
          justify-content: space-between;
          color: #151721;
          font-weight: normal;

          &:after {
            display: inline-block;
            padding: 0 5px;
            content: '|';
          }
        }
        span {
          width: 70%;
          color: #666679;
        }

        &.narrow {
          strong {
            width: 20%;
          }
          span {
            width: 80%;
          }
        }
      }
    }
  }
}
</style>
